/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Category } from './';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';
import type { FreelancerPhoto } from './';
import {
    FreelancerPhotoFromJSON,
    FreelancerPhotoFromJSONTyped,
    FreelancerPhotoToJSON,
} from './';
import type { Price } from './';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerProfile
 */
export interface FreelancerProfile {
    /**
     * 
     * @type {string}
     * @memberof FreelancerProfile
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProfile
     */
    normalizedFullname: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProfile
     */
    headline: string;
    /**
     * 
     * @type {FreelancerPhoto}
     * @memberof FreelancerProfile
     */
    photo?: FreelancerPhoto;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerProfile
     */
    malterLevels: Array<FreelancerProfileMalterLevelsEnum>;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProfile
     */
    recommendationsCount: number;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProfile
     */
    ratings: number;
    /**
     * 
     * @type {Price}
     * @memberof FreelancerProfile
     */
    price?: Price;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProfile
     */
    avgAnsweringTime?: FreelancerProfileAvgAnsweringTimeEnum;
    /**
     * 
     * @type {Category}
     * @memberof FreelancerProfile
     */
    preferredCategory?: Category;
}


/**
 * @export
 */
export const FreelancerProfileMalterLevelsEnum = {
    L1: 'SUPER_MALTER_L1',
    L2: 'SUPER_MALTER_L2',
    L3: 'SUPER_MALTER_L3'
} as const;
export type FreelancerProfileMalterLevelsEnum = typeof FreelancerProfileMalterLevelsEnum[keyof typeof FreelancerProfileMalterLevelsEnum];

/**
 * @export
 */
export const FreelancerProfileAvgAnsweringTimeEnum = {
    LessThan2H: 'LESS_THAN_2H',
    LessThan6H: 'LESS_THAN_6H',
    LessThan12H: 'LESS_THAN_12H',
    LessThan24H: 'LESS_THAN_24H',
    LessThan48H: 'LESS_THAN_48H',
    MoreThan48H: 'MORE_THAN_48H'
} as const;
export type FreelancerProfileAvgAnsweringTimeEnum = typeof FreelancerProfileAvgAnsweringTimeEnum[keyof typeof FreelancerProfileAvgAnsweringTimeEnum];


/**
 * Check if a given object implements the FreelancerProfile interface.
 */
export function instanceOfFreelancerProfile(value: object): value is FreelancerProfile {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('normalizedFullname' in value) || value['normalizedFullname'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('malterLevels' in value) || value['malterLevels'] === undefined) return false;
    if (!('recommendationsCount' in value) || value['recommendationsCount'] === undefined) return false;
    if (!('ratings' in value) || value['ratings'] === undefined) return false;
    return true;
}

export function FreelancerProfileFromJSON(json: any): FreelancerProfile {
    return FreelancerProfileFromJSONTyped(json, false);
}

export function FreelancerProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'normalizedFullname': json['normalizedFullname'],
        'headline': json['headline'],
        'photo': json['photo'] == null ? undefined : FreelancerPhotoFromJSON(json['photo']),
        'malterLevels': json['malterLevels'],
        'recommendationsCount': json['recommendationsCount'],
        'ratings': json['ratings'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'avgAnsweringTime': json['avgAnsweringTime'] == null ? undefined : json['avgAnsweringTime'],
        'preferredCategory': json['preferredCategory'] == null ? undefined : CategoryFromJSON(json['preferredCategory']),
    };
}

export function FreelancerProfileToJSON(value?: FreelancerProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'normalizedFullname': value['normalizedFullname'],
        'headline': value['headline'],
        'photo': FreelancerPhotoToJSON(value['photo']),
        'malterLevels': value['malterLevels'],
        'recommendationsCount': value['recommendationsCount'],
        'ratings': value['ratings'],
        'price': PriceToJSON(value['price']),
        'avgAnsweringTime': value['avgAnsweringTime'],
        'preferredCategory': CategoryToJSON(value['preferredCategory']),
    };
}

